module.exports = __webpack_public_path__ + "static/media/maptutorial.d6abb6e0.png";